import { XMarkIcon } from "@heroicons/react/24/outline";
import MenuItem from "./MenuItem";
import { bottomNavItemList, primaryNavItemList } from "./menu-items";
import { isTenantModuleEnabled } from "../../helpers/tenant-modules";

export const filterNavigationItems = (items, modules, isEmployee) =>
  items.reduce((visibleItems, item) => {
    if (
      (item.adminOnly && isEmployee) ||
      (item.employeeOnly && !isEmployee) ||
      (item.moduleKey && !isTenantModuleEnabled(modules, item.moduleKey))
    ) {
      return visibleItems;
    }

    if (item.children) {
      const children = filterNavigationItems(
        item.children,
        modules,
        isEmployee,
      );
      if (children.length === 0) {
        return visibleItems;
      }
      visibleItems.push({ ...item, children });
      return visibleItems;
    }

    visibleItems.push(item);
    return visibleItems;
  }, []);

function SidebarNavigation({ branding, modules, onClose, isEmployee = false }) {
  const appName = branding?.appName ?? "Loyalty Admin";
  const navigationItems = filterNavigationItems(
    primaryNavItemList,
    modules,
    isEmployee,
  );

  const bottomNavigationItems = filterNavigationItems(
    bottomNavItemList,
    modules,
    isEmployee,
  );

  return (
    <div className="flex h-full min-h-0 w-full flex-col">
      <div className="flex shrink-0 flex-row items-center justify-between">
        <div className="w-[90px] h-auto">
          {branding?.logoUrl ? (
            <img
              src={branding.logoUrl}
              alt={appName}
              className="h-auto w-full"
            />
          ) : (
            <h3 className="uppercase text-2xl font-bold">{appName}</h3>
          )}
        </div>

        {onClose ? (
          <button type="button" className="lg:hidden" onClick={onClose}>
            <XMarkIcon className="w-6 h-6 text-white" />
          </button>
        ) : null}
      </div>

      <div
        className="my-4 mx-2 mt-8 min-h-0 flex-1 overflow-y-auto"
        data-testid="primary-navigation"
      >
        <ul className="flex flex-col list-none md:min-w-full">
          {navigationItems.map((item) => (
            <MenuItem item={item} key={item.id} />
          ))}
        </ul>
      </div>

      <div
        className="mx-2 mt-auto shrink-0 border-t border-white/20 pt-2"
        data-testid="bottom-navigation"
      >
        <ul className="flex flex-col list-none md:min-w-full">
          {bottomNavigationItems.map((item) => (
            <MenuItem item={item} key={item.id} />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default SidebarNavigation;
